import * as React from 'react';
import {BundleData} from "data/BundleData";
import {observer} from "mobx-react";


import {PageWrapperWithNav} from "components/widgets/PageWrapperWithNav";
import {PageEnum} from "components/nav/PageEnums";
import {BoothPageContent} from "./BoothPageContent";
import {JoinLiveButtonBox} from "../widgets/JoinLiveButtonBox";

import './BoothPage.pcss';
import {UIState} from "../../data/UIState";

interface IBoothPage_Props {
  pageEnum:PageEnum;
  nav:any;
}
@observer
export class BoothPage extends React.Component<IBoothPage_Props> {
  render() {
    const booth = BundleData.selectedBundle;
    if(booth) {
      const topRightContent = booth.live ? <div className={'bp-top-right'}><JoinLiveButtonBox bundle={booth} zoomRegistration={booth.zoomRegistration}/></div> : null;
      return (
        <PageWrapperWithNav {...this.props} className={"booth booth-page"} extra={topRightContent} >
          <BoothPageContent
              booth={booth}
              feedData={UIState.feedData}
              user={UIState.user}
          />
        </PageWrapperWithNav>
      );
    } else {
      return null;
    }

  }
}


